import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ModalInfo from "../../../../components/ModalInfo";
import { setOpenModalVerbasComunicado, envioTermosApiVerbas, verificaTermosVerbas } from "../../../../store/actions/termos";
import { Checkbox } from "antd";

import S from "./styles";
const ModalVerbasComunicado = (props) => {

  const termosReducer = useSelector((state) => state.termos);  
  const dispatch = useDispatch();

  const [termoAceito, setTermoAceito] = useState(false);
  const [naoExibirMais, setNaoExibirMais] = useState(false);

  const fecharModal = () => {
    dispatch(setOpenModalVerbasComunicado(false));
    setTermoAceito(false);
    setNaoExibirMais(false);
  }

  const handleModal = async () => {
    const payload = {
       aceiteTermo: termoAceito,
       naoExibir: naoExibirMais
    }    

    await envioTermosApiVerbas(payload);
  }

  useEffect(() => {
    verificaTermosVerbas();
  }, []);

  return (
    termosReducer.openModalVerbasComunicado && (
      <ModalInfo
        onClose={fecharModal}
        title="Comunicado aos clientes:"
        footerRender={
          <div style={{display: 'flex', alignItems: 'center'}}>      
            <S.ModalButton disabled={!termoAceito} onClick={handleModal}>Prosseguir</S.ModalButton>
          </div>
        }
      >
        <S.ModalScroll>  
          Prezado cliente;
          <br />
          <br />    
          O módulo do INSS - Verbas Indenizatórias sofreu uma atualização. Caso V. Sa. tenha utilizado este módulo, será necessário reprocessar a apuração dos créditos.
          <br />
          Atenciosamente.
          <br />
          <br />  
          Equipe e-Auditoria        
        <br></br>
        </S.ModalScroll>   
        <Checkbox disabled={naoExibirMais} onChange={e => setTermoAceito(e.target.checked)} style={{ color: 'white', marginTop: 16 }}>
          <span style={{ color: naoExibirMais ? 'gray' : 'white' }}>Estou ciente e desejo prosseguir</span>
        </Checkbox>    
        <Checkbox disabled={!termoAceito} onChange={e => setNaoExibirMais(e.target.checked)} style={{ color: 'white', marginTop: 16 }}>
          <span style={{ color: !termoAceito ? 'gray' : 'white' }}>Não exibir mais</span>
        </Checkbox>               
      </ModalInfo>  
    )
  );
};

export default ModalVerbasComunicado;

